
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pet-owner",
      function () {
        return require("private-next-pages/pet-owner/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pet-owner"])
      });
    }
  